webpackJsonp([202923723943889,60335399758886],{

/***/ 88:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"pathPrefix":"/uptyme","siteMetadata":{"title":"UpTyme","description":"Intelligent Field Automation","image":"http://getwalk.in","url":"http://getwalk.in","type":"article","siteName":"UpTyme by Walkin","githubUrl":""}},"allMarkdownRemark":{"edges":[{"node":{"fileAbsolutePath":"/opt/build/repo/docs/geofences.md","headings":[{"value":"Geofences","depth":1},{"value":"Introduction","depth":2},{"value":"How it works","depth":2},{"value":"Create geofences","depth":2},{"value":"Size and reliability","depth":2},{"value":"Dashboard","depth":2},{"value":"Dwell time detection","depth":2},{"value":"Support","depth":2}]}},{"node":{"fileAbsolutePath":"/opt/build/repo/docs/groups.md","headings":[{"value":"Groups/Places","depth":1},{"value":"Introduction","depth":2},{"value":"How it works","depth":2},{"value":"Categories","depth":2},{"value":"Chains","depth":2},{"value":"Groups","depth":2},{"value":"Place filters","depth":2},{"value":"Verify events","depth":2},{"value":"Report inaccurate groups","depth":2},{"value":"Support","depth":2}]}},{"node":{"fileAbsolutePath":"/opt/build/repo/docs/integrations.md","headings":[{"value":"Integrations","depth":1},{"value":"Introduction","depth":2},{"value":"SDK Integration","depth":2},{"value":"Steps to integrate NearX SDK into your app:","depth":3},{"value":"Event integrations","depth":3},{"value":"Segment","depth":3},{"value":"Support","depth":2}]}},{"node":{"fileAbsolutePath":"/opt/build/repo/docs/overview.md","headings":[{"value":"Overview","depth":1},{"value":"Introduction","depth":2},{"value":"Quickstart","depth":2},{"value":"Glossary","depth":2},{"value":"Context types","depth":2},{"value":"Geofences","depth":3},{"value":"Groups","depth":3},{"value":"Developer tools","depth":2},{"value":"SDK","depth":3},{"value":"API","depth":3},{"value":"Sample Applications","depth":2},{"value":"Support","depth":2}]}},{"node":{"fileAbsolutePath":"/opt/build/repo/docs/sample.md","headings":[{"value":"Sample Applications","depth":1},{"value":"Introduction","depth":2},{"value":"Instructions","depth":2},{"value":"Support","depth":2}]}},{"node":{"fileAbsolutePath":"/opt/build/repo/docs/sdk.md","headings":[{"value":"SDK","depth":1},{"value":"Introduction","depth":2},{"value":"Accuracy and reliability","depth":2},{"value":"Authentication","depth":2},{"value":"iOS","depth":2},{"value":"Support","depth":2}]}},{"node":{"fileAbsolutePath":"/opt/build/repo/docs/api.md","headings":[{"value":"API","depth":1},{"value":"Introduction","depth":2},{"value":"Authentication","depth":2},{"value":"Errors","depth":2},{"value":"GraphQL APIs","depth":2},{"value":"Create a geofence","depth":3},{"value":"Definition","depth":4},{"value":"Query parameters","depth":4},{"value":"Sample response","depth":4},{"value":"Update a geofence","depth":3},{"value":"Definition","depth":4},{"value":"Query parameters","depth":4},{"value":"Sample response","depth":4},{"value":"Disable a geofence","depth":3},{"value":"Definition","depth":4},{"value":"Query parameters","depth":4},{"value":"Sample body","depth":4},{"value":"Sample response","depth":4},{"value":"Get a geofence","depth":3},{"value":"Definition","depth":4},{"value":"Sample body","depth":4},{"value":"Sample response","depth":4},{"value":"List geofences","depth":3},{"value":"Definition","depth":4},{"value":"Query parameters","depth":4},{"value":"Sample body","depth":4},{"value":"Sample response","depth":4},{"value":"Get Group","depth":3},{"value":"Definition","depth":4},{"value":"Query parameters","depth":4},{"value":"List Groups","depth":3},{"value":"Definition","depth":4},{"value":"Query parameters","depth":4},{"value":"Sample body","depth":4},{"value":"Sample response","depth":4},{"value":"Create Group","depth":3},{"value":"Definition","depth":4},{"value":"Query parameters","depth":4},{"value":"Sample body","depth":4},{"value":"Sample response","depth":4},{"value":"Update Group","depth":3},{"value":"Definition","depth":4},{"value":"Query parameters","depth":4},{"value":"Sample body","depth":4},{"value":"Sample response","depth":4},{"value":"Disable Group","depth":3},{"value":"Definition","depth":4},{"value":"Query parameters","depth":4},{"value":"Sample body","depth":4},{"value":"Sample response","depth":4},{"value":"Get Place","depth":3},{"value":"Definition","depth":4},{"value":"Query parameters","depth":4},{"value":"Sample body","depth":4},{"value":"Sample response","depth":4},{"value":"List Places","depth":3},{"value":"Definition","depth":4},{"value":"Query parameters","depth":4},{"value":"Sample body","depth":4},{"value":"Sample response","depth":4},{"value":"Create Or Update Place","depth":3},{"value":"Definition","depth":4},{"value":"Query parameters","depth":4},{"value":"Sample body","depth":4},{"value":"Sample response","depth":4},{"value":"Support","depth":2}]}}]},"menu":{"pages":[{"dir":"./src","file":"pages/landing.js","title":"Home","url":"/","layout":"walkin_default","relativePath":"src/pages/landing.js","absolutePath":"/opt/build/repo/docs-www/src/pages/landing.js","sidemenu":[]},{"dir":"./src","title":"Pricing","url":"/pricing","file":"pages/pricing.js","layout":"walkin_default","relativePath":"src/pages/pricing.js","absolutePath":"/opt/build/repo/docs-www/src/pages/pricing.js","sidemenu":[]},{"dir":"./src","title":"Privacy Policy","url":"/privacy_policy","file":"pages/privacy_policy.js","layout":"walkin_default","relativePath":"src/pages/privacy_policy.js","absolutePath":"/opt/build/repo/docs-www/src/pages/privacy_policy.js","sidemenu":[]},{"dir":"./src","title":"Contact Us","url":"/contactus","file":"pages/sales.js","layout":"walkin_default","relativePath":"src/pages/sales.js","absolutePath":"/opt/build/repo/docs-www/src/pages/sales.js","sidemenu":[]}]}},"layoutContext":{}}

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _walkin_default = __webpack_require__(146);
	
	var _walkin_default2 = _interopRequireDefault(_walkin_default);
	
	var _layoutWalkinDefault = __webpack_require__(88);
	
	var _layoutWalkinDefault2 = _interopRequireDefault(_layoutWalkinDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_walkin_default2.default, _extends({}, props, _layoutWalkinDefault2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GithubIcon = function GithubIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { height: "32", viewBox: "0 0 16 16", version: "1.1", width: "32", fill: "#fff" },
	    _react2.default.createElement("path", { fillRule: "evenodd", d: "M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z" })
	  );
	};
	
	exports.default = GithubIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mainModule = __webpack_require__(247);
	
	var _mainModule2 = _interopRequireDefault(_mainModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Main = function Main(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'main',
	    { className: _mainModule2.default.main },
	    children()
	  );
	};
	
	exports.default = Main;
	module.exports = exports['default'];

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"node_modules--brainhubeu-gatsby-docs-kit-src-components-main----main-module---main---25yzl"};

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(331);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_React$Component) {
	  _inherits(SEO, _React$Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var siteMetadata = this.props.siteMetadata;
	
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        siteMetadata.title
	      ),
	      siteMetadata.description && _react2.default.createElement('meta', { name: 'description', content: siteMetadata.description }),
	      siteMetadata.image && _react2.default.createElement('meta', { name: 'image', content: siteMetadata.image }),
	      siteMetadata.siteName && _react2.default.createElement('meta', { property: 'og:site_name', content: siteMetadata.siteName }),
	      siteMetadata.url && _react2.default.createElement('meta', { property: 'og:url', content: siteMetadata.url }),
	      siteMetadata.type && _react2.default.createElement('meta', { property: 'og:type', content: siteMetadata.type }),
	      siteMetadata.title && _react2.default.createElement('meta', { property: 'og:title', content: siteMetadata.title }),
	      siteMetadata.description && _react2.default.createElement('meta', { property: 'og:description', content: siteMetadata.description }),
	      siteMetadata.image && _react2.default.createElement('meta', { property: 'og:image', content: siteMetadata.image })
	    );
	  };
	
	  return SEO;
	}(_react2.default.Component);
	
	SEO.propTypes = {
	  siteMetadata: _propTypes2.default.shape({
	    description: _propTypes2.default.string,
	    image: _propTypes2.default.string,
	    url: _propTypes2.default.string,
	    type: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    siteName: _propTypes2.default.string
	  })
	};
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 326:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuPropTypes = {
	  title: _propTypes2.default.string,
	  file: _propTypes2.default.string,
	  relativePath: _propTypes2.default.string,
	  absolutePath: _propTypes2.default.string,
	  url: _propTypes2.default.string,
	  hash: _propTypes2.default.string
	};
	
	exports.default = _propTypes2.default.arrayOf(_propTypes2.default.shape({
	  title: _propTypes2.default.string,
	  dir: _propTypes2.default.string,
	  file: _propTypes2.default.string,
	  relativePath: _propTypes2.default.string,
	  absolutePath: _propTypes2.default.string,
	  template: _propTypes2.default.string,
	  layout: _propTypes2.default.string,
	  href: _propTypes2.default.string,
	  url: _propTypes2.default.string,
	  sidemenu: _propTypes2.default.arrayOf(_propTypes2.default.shape(_extends({}, menuPropTypes, {
	    items: _propTypes2.default.arrayOf(_propTypes2.default.shape(_extends({}, menuPropTypes, {
	      items: _propTypes2.default.arrayOf(_propTypes2.default.shape(menuPropTypes))
	    })))
	  })))
	}));
	module.exports = exports['default'];

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.findMatchingPage = findMatchingPage;
	
	/**
	 * Retrieve all url's from menu
	 * @param {Array} menuItems
	 * @return {Array} urls
	 */
	function getAllUrls(menuItems) {
	  if (!menuItems) {
	    return [];
	  }
	
	  return menuItems.reduce(function (acc, menuItem) {
	    acc.push(menuItem.url);
	
	    if (menuItem.items) {
	      acc.push.apply(acc, getAllUrls(menuItem.items));
	    }
	
	    return acc;
	  }, []);
	}
	
	/**
	 * Find page, that matches location pathname
	 * @param {Array} menuItems
	 * @param {String} pathname location pathname
	 * @param {String} prefix
	 * @return {Object} page config
	 */
	function findMatchingPage(menuItems, pathname) {
	  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  if (!menuItems) {
	    return false;
	  }
	
	  if (!pathname.startsWith(prefix)) {
	    return false;
	  }
	
	  var pathNameWithoutPrefix = pathname.substr(prefix.length);
	
	  return menuItems.find(function (menuItem) {
	    if (!menuItem) {
	      return false;
	    }
	
	    return pathNameWithoutPrefix === menuItem.url || getAllUrls(menuItem.sidemenu || menuItem.items).indexOf(pathNameWithoutPrefix) !== -1;
	  });
	}

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var GithubSlugger = __webpack_require__(306);
	
	var addItemToMenu = function addItemToMenu(sidemenu, file, url, hash, title, depth, currentDepth) {
	  currentDepth = currentDepth || 2; // h1 are excluded
	
	  if (depth === currentDepth) {
	    sidemenu.push({ file: file, url: '' + url + hash, title: title, items: [] });
	  } else {
	    currentDepth++;
	    var last = sidemenu.pop();
	    if (last) {
	      addItemToMenu(last.items, file, url, hash, title, depth, currentDepth);
	      sidemenu.push(last);
	    }
	  }
	};
	
	var createSideMenu = function createSideMenu(activeData, data) {
	  var slugger = new GithubSlugger();
	  activeData.depthOfMenu = (activeData.depthOfMenu || 6) + 1; // menu starts from h2
	  var sidemenu = [];
	
	  var matchedMarkdownEdge = data.allMarkdownRemark.edges.find(function (edge) {
	    return edge.node.fileAbsolutePath === activeData.absolutePath;
	  });
	
	  if (!matchedMarkdownEdge) {
	    return [];
	  }
	
	  matchedMarkdownEdge.node.headings.filter(function (child) {
	    return child.depth >= 2 && child.depth <= activeData.depthOfMenu;
	  }).map(function (child) {
	    return {
	      hash: '#' + slugger.slug(child.value),
	      depth: child.depth,
	      value: child.value
	    };
	  }).map(function (child) {
	    return addItemToMenu(sidemenu, activeData.file, activeData.url, child.hash, child.value, child.depth);
	  });
	  return sidemenu;
	};
	
	exports.default = createSideMenu;
	
	/**
	 * Determines whether page has sidemenu
	 * @param {Object} page
	 * @return {Boolean}
	 */
	
	var hasSideMenu = exports.hasSideMenu = function hasSideMenu(page) {
	  return !!page && !!page.sidemenu && !!page.sidemenu.length;
	};

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(234);
	var isArguments = __webpack_require__(233);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 233:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 234:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 241:
/***/ (function(module, exports) {

	module.exports = function() {
		return /[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2694\u2696\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD79\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED0\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3]|\uD83E[\uDD10-\uDD18\uDD80-\uDD84\uDDC0]|\uD83C\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uD83C\uDDFE\uD83C[\uDDEA\uDDF9]|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDFC\uD83C[\uDDEB\uDDF8]|\uD83C\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uD83C\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF8\uDDFE\uDDFF]|\uD83C\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uD83C\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uD83C\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uD83C\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uD83C\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uD83C\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uD83C\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uD83C\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uD83C\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uD83C\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uD83C\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uD83C\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uD83C\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uD83C\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uD83C\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uD83C\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|[#\*0-9]\u20E3/g;
	};


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(52);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(51));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(49));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(50));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var logDeprecationNotice = function logDeprecationNotice(prop, replacement) {
	  if (true) {
	    return;
	  }
	
	  console.log("\n    The \"" + prop + "\" prop is now deprecated and will be removed in the next major version\n    of \"gatsby-image\".\n    ");
	
	  if (replacement) {
	    console.log("Please use " + replacement + " instead of \"" + prop + "\".");
	  }
	}; // Handle legacy props during their deprecation phase
	
	
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends2.default)({}, props);
	  var resolutions = convertedProps.resolutions,
	      sizes = convertedProps.sizes,
	      critical = convertedProps.critical;
	
	  if (resolutions) {
	    convertedProps.fixed = resolutions;
	    delete convertedProps.resolutions;
	  }
	
	  if (sizes) {
	    convertedProps.fluid = sizes;
	    delete convertedProps.sizes;
	  }
	
	  if (critical) {
	    logDeprecationNotice("critical", "the native \"loading\" attribute");
	    convertedProps.loading = "eager";
	  }
	
	  return convertedProps;
	}; // Cache if we've seen an image before so we don't bother with
	// lazy-loading & fading in on subsequent mounts.
	
	
	var imageCache = Object.create({});
	
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props); // Find src
	
	  var src = convertedProps.fluid ? convertedProps.fluid.src : convertedProps.fixed.src;
	  return imageCache[src] || false;
	};
	
	var activateCacheForImage = function activateCacheForImage(props) {
	  var convertedProps = convertProps(props); // Find src
	
	  var src = convertedProps.fluid ? convertedProps.fluid.src : convertedProps.fixed.src;
	  imageCache[src] = true;
	}; // Native lazy-loading support: https://addyosmani.com/blog/lazy-loading/
	
	
	var hasNativeLazyLoadSupport = typeof HTMLImageElement !== "undefined" && "loading" in HTMLImageElement.prototype;
	var isBrowser = typeof window !== "undefined";
	var hasIOSupport = isBrowser && window.IntersectionObserver;
	var io;
	var listeners = new WeakMap();
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        if (listeners.has(entry.target)) {
	          var cb = listeners.get(entry.target); // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	
	          if (entry.isIntersecting || entry.intersectionRatio > 0) {
	            io.unobserve(entry.target);
	            listeners.delete(entry.target);
	            cb();
	          }
	        }
	      });
	    }, {
	      rootMargin: "200px"
	    });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  var observer = getIO();
	
	  if (observer) {
	    observer.observe(el);
	    listeners.set(el, cb);
	  }
	
	  return function () {
	    observer.unobserve(el);
	    listeners.delete(el);
	  };
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var srcSetWebp = props.srcSetWebp ? "<source type='image/webp' srcset=\"" + props.srcSetWebp + "\" " + sizes + "/>" : "";
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var crossOrigin = props.crossOrigin ? "crossorigin=\"" + props.crossOrigin + "\" " : "";
	  var loading = props.loading ? "loading=\"" + props.loading + "\" " : "";
	  return "<picture>" + srcSetWebp + "<img " + loading + width + height + sizes + srcSet + src + alt + title + crossOrigin + "style=\"position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center\"/></picture>";
	};
	
	var Img = _react.default.forwardRef(function (props, ref) {
	  var sizes = props.sizes,
	      srcSet = props.srcSet,
	      src = props.src,
	      style = props.style,
	      onLoad = props.onLoad,
	      onError = props.onError,
	      loading = props.loading,
	      otherProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["sizes", "srcSet", "src", "style", "onLoad", "onError", "loading"]);
	  return _react.default.createElement("img", (0, _extends2.default)({
	    sizes: sizes,
	    srcSet: srcSet,
	    src: src
	  }, otherProps, {
	    onLoad: onLoad,
	    onError: onError,
	    ref: ref,
	    loading: loading,
	    style: (0, _extends2.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	});
	
	Img.propTypes = {
	  style: _propTypes.default.object,
	  onError: _propTypes.default.func,
	  onLoad: _propTypes.default.func
	};
	
	var Image =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Image, _React$Component);
	
	  function Image(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this; // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	
	    _this.seenBefore = isBrowser && inImageCache(props);
	    _this.addNoScript = !(props.critical && !props.fadeIn);
	    _this.useIOSupport = !hasNativeLazyLoadSupport && hasIOSupport && !props.critical && !_this.seenBefore;
	    var isVisible = props.critical || isBrowser && (hasNativeLazyLoadSupport || !_this.useIOSupport);
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: false,
	      imgCached: false,
	      fadeIn: !_this.seenBefore && props.fadeIn
	    };
	    _this.imageRef = _react.default.createRef();
	    _this.handleImageLoaded = _this.handleImageLoaded.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleRef = _this.handleRef.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = Image.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    if (this.state.isVisible && typeof this.props.onStartLoad === "function") {
	      this.props.onStartLoad({
	        wasCached: inImageCache(this.props)
	      });
	    }
	
	    if (this.props.critical) {
	      var img = this.imageRef.current;
	
	      if (img && img.complete) {
	        this.handleImageLoaded();
	      }
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    if (this.cleanUpListeners) {
	      this.cleanUpListeners();
	    }
	  }; // Specific to IntersectionObserver based lazy-load support
	
	
	  _proto.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.useIOSupport && ref) {
	      this.cleanUpListeners = listenToIntersections(ref, function () {
	        var imageInCache = inImageCache(_this2.props);
	
	        if (!_this2.state.isVisible && typeof _this2.props.onStartLoad === "function") {
	          _this2.props.onStartLoad({
	            wasCached: imageInCache
	          });
	        } // imgCached and imgLoaded must update after isVisible,
	        // Once isVisible is true, imageRef becomes accessible, which imgCached needs access to.
	        // imgLoaded and imgCached are in a 2nd setState call to be changed together,
	        // avoiding initiating unnecessary animation frames from style changes.
	
	
	        _this2.setState({
	          isVisible: true
	        }, function () {
	          return _this2.setState({
	            imgLoaded: imageInCache,
	            // `currentSrc` should be a string, but can be `undefined` in IE,
	            // !! operator validates the value is not undefined/null/""
	            imgCached: !!_this2.imageRef.current.currentSrc
	          });
	        });
	      });
	    }
	  };
	
	  _proto.handleImageLoaded = function handleImageLoaded() {
	    activateCacheForImage(this.props);
	    this.setState({
	      imgLoaded: true
	    });
	
	    if (this.props.onLoad) {
	      this.props.onLoad();
	    }
	  };
	
	  _proto.render = function render() {
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === void 0 ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === void 0 ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === void 0 ? {} : _convertProps$placeho,
	        placeholderClassName = _convertProps.placeholderClassName,
	        fluid = _convertProps.fluid,
	        fixed = _convertProps.fixed,
	        backgroundColor = _convertProps.backgroundColor,
	        durationFadeIn = _convertProps.durationFadeIn,
	        Tag = _convertProps.Tag,
	        itemProp = _convertProps.itemProp,
	        loading = _convertProps.loading;
	
	    var shouldReveal = this.state.fadeIn === false || this.state.imgLoaded;
	    var shouldFadeIn = this.state.fadeIn === true && !this.state.imgCached;
	    var imageStyle = (0, _extends2.default)({
	      opacity: shouldReveal ? 1 : 0,
	      transition: shouldFadeIn ? "opacity " + durationFadeIn + "ms" : "none"
	    }, imgStyle);
	    var bgColor = typeof backgroundColor === "boolean" ? "lightgray" : backgroundColor;
	    var delayHideStyle = {
	      transitionDelay: durationFadeIn + "ms"
	    };
	    var imagePlaceholderStyle = (0, _extends2.default)({
	      opacity: this.state.imgLoaded ? 0 : 1
	    }, shouldFadeIn && delayHideStyle, imgStyle, placeholderStyle);
	    var placeholderImageProps = {
	      title: title,
	      alt: !this.state.isVisible ? alt : "",
	      style: imagePlaceholderStyle,
	      className: placeholderClassName
	    };
	
	    if (fluid) {
	      var image = fluid;
	      return _react.default.createElement(Tag, {
	        className: (className ? className : "") + " gatsby-image-wrapper",
	        style: (0, _extends2.default)({
	          position: "relative",
	          overflow: "hidden"
	        }, style),
	        ref: this.handleRef,
	        key: "fluid-" + JSON.stringify(image.srcSet)
	      }, _react.default.createElement(Tag, {
	        style: {
	          width: "100%",
	          paddingBottom: 100 / image.aspectRatio + "%"
	        }
	      }), bgColor && _react.default.createElement(Tag, {
	        title: title,
	        style: (0, _extends2.default)({
	          backgroundColor: bgColor,
	          position: "absolute",
	          top: 0,
	          bottom: 0,
	          opacity: !this.state.imgLoaded ? 1 : 0,
	          right: 0,
	          left: 0
	        }, shouldFadeIn && delayHideStyle)
	      }), image.base64 && _react.default.createElement(Img, (0, _extends2.default)({
	        src: image.base64
	      }, placeholderImageProps)), image.tracedSVG && _react.default.createElement(Img, (0, _extends2.default)({
	        src: image.tracedSVG
	      }, placeholderImageProps)), this.state.isVisible && _react.default.createElement("picture", null, image.srcSetWebp && _react.default.createElement("source", {
	        type: "image/webp",
	        srcSet: image.srcSetWebp,
	        sizes: image.sizes
	      }), _react.default.createElement(Img, {
	        alt: alt,
	        title: title,
	        sizes: image.sizes,
	        src: image.src,
	        crossOrigin: this.props.crossOrigin,
	        srcSet: image.srcSet,
	        style: imageStyle,
	        ref: this.imageRef,
	        onLoad: this.handleImageLoaded,
	        onError: this.props.onError,
	        itemProp: itemProp,
	        loading: loading
	      })), this.addNoScript && _react.default.createElement("noscript", {
	        dangerouslySetInnerHTML: {
	          __html: noscriptImg((0, _extends2.default)({
	            alt: alt,
	            title: title,
	            loading: loading
	          }, image))
	        }
	      }));
	    }
	
	    if (fixed) {
	      var _image = fixed;
	      var divStyle = (0, _extends2.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      return _react.default.createElement(Tag, {
	        className: (className ? className : "") + " gatsby-image-wrapper",
	        style: divStyle,
	        ref: this.handleRef,
	        key: "fixed-" + JSON.stringify(_image.srcSet)
	      }, bgColor && _react.default.createElement(Tag, {
	        title: title,
	        style: (0, _extends2.default)({
	          backgroundColor: bgColor,
	          width: _image.width,
	          opacity: !this.state.imgLoaded ? 1 : 0,
	          height: _image.height
	        }, shouldFadeIn && delayHideStyle)
	      }), _image.base64 && _react.default.createElement(Img, (0, _extends2.default)({
	        src: _image.base64
	      }, placeholderImageProps)), _image.tracedSVG && _react.default.createElement(Img, (0, _extends2.default)({
	        src: _image.tracedSVG
	      }, placeholderImageProps)), this.state.isVisible && _react.default.createElement("picture", null, _image.srcSetWebp && _react.default.createElement("source", {
	        type: "image/webp",
	        srcSet: _image.srcSetWebp,
	        sizes: _image.sizes
	      }), _react.default.createElement(Img, {
	        alt: alt,
	        title: title,
	        width: _image.width,
	        height: _image.height,
	        sizes: _image.sizes,
	        src: _image.src,
	        crossOrigin: this.props.crossOrigin,
	        srcSet: _image.srcSet,
	        style: imageStyle,
	        ref: this.imageRef,
	        onLoad: this.handleImageLoaded,
	        onError: this.props.onError,
	        itemProp: itemProp,
	        loading: loading
	      })), this.addNoScript && _react.default.createElement("noscript", {
	        dangerouslySetInnerHTML: {
	          __html: noscriptImg((0, _extends2.default)({
	            alt: alt,
	            title: title,
	            loading: loading
	          }, _image))
	        }
	      }));
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  durationFadeIn: 500,
	  alt: "",
	  Tag: "div",
	  // We set it to `lazy` by default because it's best to default to a performant
	  // setting and let the user "opt out" to `eager`
	  loading: "lazy"
	};
	
	var fixedObject = _propTypes.default.shape({
	  width: _propTypes.default.number.isRequired,
	  height: _propTypes.default.number.isRequired,
	  src: _propTypes.default.string.isRequired,
	  srcSet: _propTypes.default.string.isRequired,
	  base64: _propTypes.default.string,
	  tracedSVG: _propTypes.default.string,
	  srcWebp: _propTypes.default.string,
	  srcSetWebp: _propTypes.default.string
	});
	
	var fluidObject = _propTypes.default.shape({
	  aspectRatio: _propTypes.default.number.isRequired,
	  src: _propTypes.default.string.isRequired,
	  srcSet: _propTypes.default.string.isRequired,
	  sizes: _propTypes.default.string.isRequired,
	  base64: _propTypes.default.string,
	  tracedSVG: _propTypes.default.string,
	  srcWebp: _propTypes.default.string,
	  srcSetWebp: _propTypes.default.string
	});
	
	Image.propTypes = {
	  resolutions: fixedObject,
	  sizes: fluidObject,
	  fixed: fixedObject,
	  fluid: fluidObject,
	  fadeIn: _propTypes.default.bool,
	  durationFadeIn: _propTypes.default.number,
	  title: _propTypes.default.string,
	  alt: _propTypes.default.string,
	  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	  // Support Glamor's css prop.
	  critical: _propTypes.default.bool,
	  crossOrigin: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
	  style: _propTypes.default.object,
	  imgStyle: _propTypes.default.object,
	  placeholderStyle: _propTypes.default.object,
	  placeholderClassName: _propTypes.default.string,
	  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
	  onLoad: _propTypes.default.func,
	  onError: _propTypes.default.func,
	  onStartLoad: _propTypes.default.func,
	  Tag: _propTypes.default.string,
	  itemProp: _propTypes.default.string,
	  loading: _propTypes.default.oneOf(["auto", "lazy", "eager"])
	};
	var _default = Image;
	exports.default = _default;

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	var emoji = __webpack_require__(241)
	
	module.exports = BananaSlug
	
	function BananaSlug () {
	  var self = this
	  if (!(self instanceof BananaSlug)) return new BananaSlug()
	
	  self.reset()
	}
	
	/**
	 * Generate a unique slug.
	 * @param  {string} value String of text to slugify
	 * @param  {boolean} [false] Keep the current case, otherwise make all lowercase
	 * @return {string}       A unique slug string
	 */
	BananaSlug.prototype.slug = function (value, maintainCase) {
	  maintainCase = maintainCase === true
	  var self = this
	  var slug = slugger(value, maintainCase)
	  var occurrences = self.occurrences[slug]
	
	  if (self.occurrences.hasOwnProperty(slug)) {
	    occurrences++
	  } else {
	    occurrences = 0
	  }
	
	  self.occurrences[slug] = occurrences
	
	  if (occurrences) {
	    slug = slug + '-' + occurrences
	  }
	
	  return slug
	}
	
	/**
	 * Reset - Forget all previous slugs
	 * @return void
	 */
	BananaSlug.prototype.reset = function () {
	  this.occurrences = {}
	}
	
	var whitespace = /\s/g
	
	function lower (string) {
	  return string.toLowerCase()
	}
	
	function slugger (string, maintainCase) {
	  var re = /[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g
	  var replacement = '-'
	
	  if (typeof string !== 'string') return ''
	  if (!maintainCase) string = string.replace(/[A-Z]+/g, lower)
	  return string.trim()
	    .replace(re, '')
	    .replace(emoji(), '')
	    .replace(whitespace, replacement)
	}


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(333);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(232);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(332);
	
	var _HelmetConstants = __webpack_require__(130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(89);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(246));
	var shallowEqual = _interopDefault(__webpack_require__(348));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 348:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _footerModule = __webpack_require__(248);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	var _linkedin = __webpack_require__(357);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	var _Glassdoor = __webpack_require__(355);
	
	var _Glassdoor2 = _interopRequireDefault(_Glassdoor);
	
	var _gatsbyImage = __webpack_require__(83);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: _footerModule2.default.footer },
	    _react2.default.createElement(
	      'div',
	      { className: _footerModule2.default.footer__two__column_badge },
	      _react2.default.createElement(
	        'div',
	        { className: _footerModule2.default.footer__two__column__badge__container__box },
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.linkedin.com/company/first-walkin-technologies/', target: '_blank' },
	          _react2.default.createElement('img', { src: _linkedin2.default, height: '24px' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _footerModule2.default.footer__two__column__badge__container__box },
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.glassdoor.co.in/Overview/Working-at-WalkIn-EI_IE2606707.11,17.htm', target: '_blank' },
	          _react2.default.createElement('img', { src: _Glassdoor2.default, height: '20px' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\xA9 2019 ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://getwalk.in', target: '_blank' },
	        'First Walkin Pvt Ltd'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _footerModule2.default.footer__two__column_badge },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/privacy_policy', className: _footerModule2.default['landing__btn'] },
	          _react2.default.createElement(
	            'span',
	            null,
	            'Privacy Policy'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"footer__two__column_badge":"src-components-footer----footer-module---footer__two__column_badge---2KbeW","footer__two__column__badge__container__box":"src-components-footer----footer-module---footer__two__column__badge__container__box---h10Kn"};

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _menuProptypes = __webpack_require__(93);
	
	var _menuProptypes2 = _interopRequireDefault(_menuProptypes);
	
	var _GithubIcon = __webpack_require__(138);
	
	var _GithubIcon2 = _interopRequireDefault(_GithubIcon);
	
	var _uptyme_logo = __webpack_require__(369);
	
	var _uptyme_logo2 = _interopRequireDefault(_uptyme_logo);
	
	var _headerModule = __webpack_require__(249);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.componentDidMount = function () {
	      var listChildren = Array.from(_this.listRef.current.children[0].children);
	      _this.listItemWidth = _this.getItemListWidth(listChildren) + 60;
	      // this.listItemWith=150;
	
	      _this.setState({
	        mobileMenu: _this.listRef.current.clientWidth < _this.listItemWidth
	      });
	
	      window.addEventListener('resize', _this.updateDimensions);
	    };
	
	    _this.updateDimensions = function () {
	      _this.setState({
	        mobileMenu: _this.listRef.current.clientWidth < _this.listItemWidth
	      });
	    };
	
	    _this.getItemListWidth = function (navArray) {
	      var navWidth = 0;
	
	      navArray.forEach(function (element) {
	        navWidth += element.clientWidth;
	      });
	
	      return navWidth;
	    };
	
	    _this.toggleMenu = function () {
	      _this.setState({ menuIsOpen: !_this.state.menuIsOpen });
	    };
	
	    _this.listRef = _react2.default.createRef();
	    _this.listItemWith = 0;
	
	    _this.state = {
	      mobileMenu: false,
	      mainNavItemsWidth: 0,
	      menuIsOpen: false
	    };
	    return _this;
	  }
	
	  Header.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this.updateDimensions);
	  };
	
	  Header.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        menuPages = _props.menuPages,
	        activeNavTitle = _props.activeNavTitle,
	        githubUrl = _props.githubUrl;
	
	    return _react2.default.createElement(
	      'header',
	      {
	        className: (0, _classnames2.default)([_headerModule2.default.header, this.state.mobileMenu && _headerModule2.default['header--mobile']])
	      },
	      _react2.default.createElement('img', { src: _uptyme_logo2.default, height: '48px', alt: 'UpTyme', title: 'UpTyme' }),
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.header__menuWrapper },
	        _react2.default.createElement(
	          'nav',
	          { className: _headerModule2.default.header__nav, ref: this.listRef },
	          _react2.default.createElement(
	            'ul',
	            {
	              className: (0, _classnames2.default)([_headerModule2.default.nav__list, this.state.menuIsOpen && _headerModule2.default['nav__list--mobile__open']])
	
	            },
	            menuPages.map(function (element, index) {
	              return _react2.default.createElement(
	                'li',
	                { key: index, className: _headerModule2.default.nav__item },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    to: element.url,
	                    className: (0, _classnames2.default)([_headerModule2.default.nav__link, activeNavTitle === element.title ? _headerModule2.default['nav__link--active'] : null]),
	                    'data-after': element.title,
	                    onClick: _this2.toggleMenu
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    element.title
	                  )
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _headerModule2.default.menu__btnsWrapper },
	          githubUrl && _react2.default.createElement(
	            'a',
	            { href: githubUrl, target: '_blank', className: _headerModule2.default.header__github },
	            _react2.default.createElement(_GithubIcon2.default, null)
	          ),
	          this.state.mobileMenu && _react2.default.createElement(
	            'button',
	            {
	              className: (0, _classnames2.default)([_headerModule2.default.header__mobileBtn, this.state.menuIsOpen && _headerModule2.default['header__mobileBtn--active']]),
	              onClick: this.toggleMenu
	            },
	            _react2.default.createElement('span', { className: _headerModule2.default.mobileBtn__hamburger })
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	Header.propTypes = {
	  location: _propTypes2.default.string,
	  activeNavTitle: _propTypes2.default.string,
	  menuPages: _menuProptypes2.default,
	  githubUrl: _propTypes2.default.string
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"src-components-header----header-module---header---3QwAt","header--mobile":"src-components-header----header-module---header--mobile---2-RNA","nav__list":"src-components-header----header-module---nav__list---1eCty","nav__list--mobile__open":"src-components-header----header-module---nav__list--mobile__open---qWSzI","fromTop":"src-components-header----header-module---fromTop---1t6xx","nav__item":"src-components-header----header-module---nav__item---14wsO","nav__link":"src-components-header----header-module---nav__link---27-lH","header__logo":"src-components-header----header-module---header__logo---1G9WW","header__menuWrapper":"src-components-header----header-module---header__menuWrapper---IjyDR","header__nav":"src-components-header----header-module---header__nav---XspGw","nav__link--active":"src-components-header----header-module---nav__link--active---kP6J0","menu__btnsWrapper":"src-components-header----header-module---menu__btnsWrapper---H-XUT","header__mobileBtn":"src-components-header----header-module---header__mobileBtn---1tejZ","mobileBtn__hamburger":"src-components-header----header-module---mobileBtn__hamburger---3uB6P","header__mobileBtn--active":"src-components-header----header-module---header__mobileBtn--active---xzUpe","header__github":"src-components-header----header-module---header__github---2D8xy","opacity":"src-components-header----header-module---opacity---lOOg0"};

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _sideNavModule = __webpack_require__(250);
	
	var _sideNavModule2 = _interopRequireDefault(_sideNavModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createMenuList = function createMenuList(listData, location) {
	  return _react2.default.createElement(
	    'ul',
	    { className: _sideNavModule2.default.sideNav__sideList },
	    listData.map(function (element) {
	      return _react2.default.createElement(
	        'li',
	        { key: element.title, className: _sideNavModule2.default.sideList__item },
	        element.file && _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: element.url || element.href,
	            className: (0, _classnames2.default)([_sideNavModule2.default.subNav__link, location === element.url && _sideNavModule2.default['subNav__link--active']])
	          },
	          element.title
	        ),
	        !element.file && _react2.default.createElement(
	          'span',
	          { className: _sideNavModule2.default.subNav__header },
	          element.title
	        ),
	        element.items && createMenuList(element.items, location)
	      );
	    })
	  );
	};
	
	var SideNav = function SideNav(_ref) {
	  var activeNavData = _ref.activeNavData,
	      location = _ref.location;
	  return _react2.default.createElement(
	    'div',
	    { className: _sideNavModule2.default.sideNav__scrollableWrapper },
	    _react2.default.createElement(
	      'nav',
	      { className: _sideNavModule2.default.sideNav },
	      createMenuList(activeNavData.sidemenu, location)
	    )
	  );
	};
	
	exports.default = SideNav;
	module.exports = exports['default'];

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sideNav":"src-components-sideNav----sideNav-module---sideNav---2liBa","sideNav__scrollableWrapper":"src-components-sideNav----sideNav-module---sideNav__scrollableWrapper---YLFsG","sideNav__sideList":"src-components-sideNav----sideNav-module---sideNav__sideList---2Hu18","subNav__header":"src-components-sideNav----sideNav-module---subNav__header---dyaqk","subNav__link":"src-components-sideNav----sideNav-module---subNav__link---1Y03e","subNav__link--active":"src-components-sideNav----sideNav-module---subNav__link--active---1lHwo","sideNav__slideList":"src-components-sideNav----sideNav-module---sideNav__slideList---Op-Ht"};

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _menuProptypes = __webpack_require__(93);
	
	var _menuProptypes2 = _interopRequireDefault(_menuProptypes);
	
	var _navigation = __webpack_require__(141);
	
	var _Header = __webpack_require__(144);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SideNav = __webpack_require__(145);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _Main = __webpack_require__(139);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Footer = __webpack_require__(143);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _sideMenu = __webpack_require__(142);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _seo = __webpack_require__(140);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	__webpack_require__(326);
	
	__webpack_require__(327);
	
	__webpack_require__(325);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPathName = function getPathName(location) {
	  var pathNamePrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var pathName = location.pathname;
	
	  if (pathName === '/') {
	    return pathName;
	  }
	
	  if (pathNamePrefix && pathNamePrefix.trim() && pathName.startsWith(pathNamePrefix)) {
	    pathName = pathName.substring(pathNamePrefix.length, pathName.length);
	  }
	
	  if (pathName.substring(pathName.length - 1) === '/') {
	    pathName = pathName.substring(0, pathName.length - 1);
	  }
	
	  return pathName;
	};
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    _classCallCheck(this, Layout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Layout.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        data = _props.data,
	        location = _props.location;
	
	    var pathName = getPathName(location, this.props.data.site.pathPrefix);
	
	    var activeData = (0, _navigation.findMatchingPage)(this.props.data.menu.pages, pathName);
	
	    if (activeData && activeData.file && !(0, _sideMenu.hasSideMenu)(activeData)) {
	      activeData.sidemenu = (0, _sideMenu2.default)(activeData, data);
	    }
	
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_seo2.default, { siteMetadata: data.site.siteMetadata }),
	      _react2.default.createElement(_Header2.default, {
	        menuPages: data.menu.pages || [],
	        activeNavTitle: activeData && activeData.title,
	        githubUrl: data.site.siteMetadata.githubUrl
	      }),
	      (0, _sideMenu.hasSideMenu)(activeData) && _react2.default.createElement(_SideNav2.default, { activeNavData: activeData, location: pathName + location.hash }),
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          _Main2.default,
	          null,
	          children
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      )
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	Layout.propTypes = {
	  children: _propTypes2.default.func,
	  location: _propTypes2.default.shape({
	    pathname: _propTypes2.default.string
	  }),
	  data: _propTypes2.default.shape({
	    site: _propTypes2.default.shape({
	      pathPrefix: _propTypes2.default.string,
	      siteMetadata: _propTypes2.default.shape({
	        description: _propTypes2.default.string,
	        image: _propTypes2.default.string,
	        url: _propTypes2.default.string,
	        type: _propTypes2.default.string,
	        title: _propTypes2.default.string,
	        siteName: _propTypes2.default.string,
	        githubUrl: _propTypes2.default.string
	      })
	    }),
	    menu: _propTypes2.default.shape({
	      pages: _menuProptypes2.default
	    }).isRequired
	  })
	};
	exports.default = Layout;
	
	// @TODO Figure out way to avoid globals
	// eslint-disable-next-line no-undef
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9Ii1tcy10cmFuc2Zvcm06IHJvdGF0ZSgzNjBkZWcpOyAtd2Via2l0LXRyYW5zZm9ybTogcm90YXRlKDM2MGRlZyk7IHRyYW5zZm9ybTogcm90YXRlKDM2MGRlZyk7Ij48cGF0aCBkPSJNMTcuMTQ0IDIwLjU3MkgzLjQzQTMuNDI3IDMuNDI3IDAgMCAwIDYuODU2IDI0aDEwLjI4NmEzLjQyOCAzLjQyOCAwIDAgMCAzLjQyOC0zLjQyOFY2LjQ5MmEuMTIzLjEyMyAwIDAgMC0uMTI0LS4xMjVoLTMuMThhLjEyNS4xMjUgMCAwIDAtLjEyMy4xMjZ2MTQuMDh6bTAtMjAuNTcyYTMuNDI5IDMuNDI5IDAgMCAxIDMuNDI3IDMuNDNINi44NTh2MTQuMDc4YS4xMjYuMTI2IDAgMCAxLS4xMjUuMTI1SDMuNTU0YS4xMjUuMTI1IDAgMCAxLS4xMjUtLjEyNVYzLjQyOEEzLjQyOSAzLjQyOSAwIDAgMSA2Ljg1NiAwaDEwLjI4NyIgZmlsbD0iIzBCQTk0MSIvPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0icmdiYSgwLCAwLCAwLCAwKSIgLz48L3N2Zz4="

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDQ4IiBoZWlnaHQ9IjUxMiIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQgbWVldCIgdmlld0JveD0iMCAwIDQ0OCA1MTIiIHN0eWxlPSItbXMtdHJhbnNmb3JtOiByb3RhdGUoMzYwZGVnKTsgLXdlYmtpdC10cmFuc2Zvcm06IHJvdGF0ZSgzNjBkZWcpOyB0cmFuc2Zvcm06IHJvdGF0ZSgzNjBkZWcpOyI+PHBhdGggZD0iTTQxNiAzMkgzMS45QzE0LjMgMzIgMCA0Ni41IDAgNjQuM3YzODMuNEMwIDQ2NS41IDE0LjMgNDgwIDMxLjkgNDgwSDQxNmMxNy42IDAgMzItMTQuNSAzMi0zMi4zVjY0LjNjMC0xNy44LTE0LjQtMzIuMy0zMi0zMi4zek0xMzUuNCA0MTZINjlWMjAyLjJoNjYuNVY0MTZ6bS0zMy4yLTI0M2MtMjEuMyAwLTM4LjUtMTcuMy0zOC41LTM4LjVTODAuOSA5NiAxMDIuMiA5NmMyMS4yIDAgMzguNSAxNy4zIDM4LjUgMzguNSAwIDIxLjMtMTcuMiAzOC41LTM4LjUgMzguNXptMjgyLjEgMjQzaC02Ni40VjMxMmMwLTI0LjgtLjUtNTYuNy0zNC41LTU2LjctMzQuNiAwLTM5LjkgMjctMzkuOSA1NC45VjQxNmgtNjYuNFYyMDIuMmg2My43djI5LjJoLjljOC45LTE2LjggMzAuNi0zNC41IDYyLjktMzQuNSA2Ny4yIDAgNzkuNyA0NC4zIDc5LjcgMTAxLjlWNDE2eiIgZmlsbD0iIzAwNzNCMSIvPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSI0NDgiIGhlaWdodD0iNTEyIiBmaWxsPSJyZ2JhKDAsIDAsIDAsIDApIiAvPjwvc3ZnPg=="

/***/ }),

/***/ 369:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-walkin-default-js-f34b0eac2108fe2a1052.js